import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/dragonBrand2910"; // DRAGON_BRAND_2910
import "@/lib/abasAntigas0311"; // ABAS_ANTIGAS_WHATS_0311
import App from "@/App";
import { cleanAppliedUpdateUrl } from "@/utils/hardReload";

cleanAppliedUpdateUrl();

document.documentElement.setAttribute('data-office-design', 'sigma');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
